import { html as n, when as o, repeat as i } from "@microsoft/fast-element";
const s = (c) => {
  const t = n.partial(c.prefix);
  return n`
    <div class="control" part="control">
      <${t}-table variant="${(e) => e.variant}">
        <${t}-thead>
          <${t}-trow>
            ${o(
    (e) => e.checkboxSelection,
    n`
                <${t}-tcell>
                  <${t}-checkbox
                    checked="${(e) => e.allChecked}"
                    indeterminate="${(e) => e.isIndeterminate}"
                    @change="${(e) => e.toggleAllRows()}"
                  ></${t}-checkbox>
                </${t}-tcell>
              `
  )}
            ${i(
    (e) => e.columns,
    n`
                <${t}-tcell
                  align="${(e, a) => a.parent.getTableCellAlignment(e.id)}"
                  width="${(e) => e.width}"
                  ?data-sortable="${(e) => e.sortable}"
                  data-sort="${(e, a) => a.parent.getSortDirection(e.id)}"
                  @click="${(e, a) => a.parent.sortByColumn(e)}"
                >
                  <span class="title">${(e) => e.title}</span>
                  ${o(
      (e) => e.sortable,
      n`
                      <${t}-icon
                        name="${(e, a) => a.parent.getSortIcon(e.id)}"
                        size="1.25em"
                        class="sort-icon"
                      />
                    `
    )}
                </${t}-tcell>
              `
  )}
          </${t}-trow>
        </${t}-thead>
        ${i(
    (e) => e.rows,
    n`
            <${t}-trow>
              ${o(
      (e, a) => a.parent.checkboxSelection,
      n`
                  <${t}-tcell>
                    <${t}-checkbox
                      checked="${(e) => e.__checked}"
                      @change="${(e, a) => a.parent.selectRow(e)}"
                    ></${t}-checkbox>
                  </${t}-tcell>
                `
    )}
              ${i(
      (e, a) => a.parent.columns,
      (e, a) => {
        const r = a.source;
        return n`
                    <${t}-tcell
                      align="${(l, $) => $.parentContext.parent.getTableCellAlignment(l.id)}"
                    >
                      ${(l) => r[l.id]}
                    </${t}-tcell>
                  `;
      }
    )}
            </${t}-trow>
          `
  )}
      </${t}-table>
      <div class="footer" part="footer">
        ${o(
    (e) => e.showPagination,
    n`
            <${t}-table-pagination
              page="${(e) => e.pagination.page}"
              pageSize="${(e) => e.pagination.pageSize}"
              total="${(e) => e.pagination.total}"
              pageSizeOptions="${(e) => JSON.stringify(e.pagination.pageSizeOptions)}"
            />
          `
  )}
      </div>
    </div>
  `;
};
export {
  s as dataGridTemplate
};
